export default __webpack_public_path__ + "static/media/divorce.81a876cd.svg";